import Image from 'next/image';

import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { SOCIAL_CARD_TYPE, socialCardKeys } from '@/src/constants/socialcard.constant'
import dayjs from 'dayjs';

import { textColors, cardColors } from '@/src/constants/wall.constant';

import ClassNames from '@/src/components/componentHelper/ClassNames'

import RenderGraphicIcon from './RenderGraphicIcon';

import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'

const GraphicCard = ({ cardWidth, cardItem,fontStyle, darkModeEnabled, cardFontColor, cardBackgroundObject, darkCardTheme, linkColor, highlightColor, engagementDisabled, smallSize, refresh, shortenText, isDateTimeDisabled, ratingColor, quotationColor }) => {

 
  const options = {
    replace: domNode => {
       const attribProps = attributesToProps(domNode.attribs);

       if (domNode.name === 'a') {
          return <a {...attribProps} style={linkColor && linkColor!=='#0b57a8'?{color: linkColor} :darkModeEnabled ? { color: '#6fb0f6' } : { color: '#0b57a8' }}>{domToReact(domNode.children, options)}</a>
       }
       else if(domNode.name === 'b'){
        let bStyle = highlightColor ? { backgroundColor: highlightColor } : { backgroundColor: '#fcf807' };
        if (darkModeEnabled) {
          bStyle.color = '#726c6c';
        }
        return <b style={bStyle}>{domToReact(domNode.children, options)}</b>
     }
    }
 }

    return (
        <div
         className="mx-auto" 
         style={{maxWidth: "40rem",minWidth:cardWidth}}>
      
      <div 
      className="graphic-main-encloser" 
      style={
        darkModeEnabled? 
          { ...(cardBackgroundObject?cardBackgroundObject:{}), border:'2px solid #fff'} :
          {...(cardBackgroundObject?cardBackgroundObject:{}),  border:'2px solid #000' }
      }
      >

  <div className="graphic-profile-area">
    <a className="graphic-profile-image" href={cardItem[socialCardKeys.messageLink] || void(0)} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer">
  
       {
                     cardItem[socialCardKeys.authorImage]?
                     <Image
                     src={cardItem[socialCardKeys.authorImage] || `https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`}
                     priority={true}
                     alt=""
                     style={{ objectFit: "contain" }}
                     width={50}
                     height={50}
                   />
                                     :
                  <img  src={`https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`} alt="" className="object-contain" width="50px" height="50px" style={{ minWidth: '3rem' }}/>
                  } 
    </a>
    <div className={ClassNames("graphic-designation-header",fontStyle && fontStyle!==''?`font-${fontStyle}`:'')} >
      <div className='flex space-x-2'>
    <a className={ClassNames(( (cardItem[socialCardKeys.workTitle] && cardItem[socialCardKeys.workTitle]!=='') || (cardItem[socialCardKeys.authorTagline] && cardItem[socialCardKeys.authorTagline]!=='') || (cardItem[socialCardKeys.authorUsername] && cardItem[socialCardKeys.authorUsername]!==''))?'':'mt-2')} href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary), textDecoration: 'none', fontSize:'16px', fontWeight:'700', lineHeight:'16px', marginBottom:'5px', letterSpacing:'-0.02em' } : { color: (cardFontColor || textColors.light.primary), textDecoration: 'none',  fontSize:'16px', fontWeight:'700', lineHeight:'16px', marginBottom:'5px', letterSpacing:'-0.02em'  }} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer noopener">
          {cardItem[socialCardKeys.authorName]}
        </a>
        
          {cardItem[socialCardKeys.authorIsVerifiedBadge] && <div className={ClassNames(( (cardItem[socialCardKeys.workTitle] && cardItem[socialCardKeys.workTitle]!=='') || (cardItem[socialCardKeys.authorTagline] && cardItem[socialCardKeys.authorTagline]!=='') || (cardItem[socialCardKeys.authorUsername] && cardItem[socialCardKeys.authorUsername]!==''))?'':'mt-2')}>
            <Image loading='lazy' alt="" src={'/TwitterVerified.svg'} width="18px" height="18px" style={{ marginTop: '2px', marginLeft: '5px' }} />
            </div>
            }

        </div>
        { (cardItem[socialCardKeys.workTitle] && cardItem[socialCardKeys.workTitle]!=='')  ?
        <a className='text-base' href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary), textDecoration: 'none', fontSize:'14px', fontWeight:'400', lineHeight:'15px', letterSpacing:'-0.005em', margin:'2px 0px 0px 0px' } : { color: (cardFontColor || textColors.light.primary), textDecoration: 'none', fontSize:'14px', fontWeight:'400', lineHeight:'15px', letterSpacing:'-0.005em', margin:'2px 0px 0px 0px' }} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer noopener">
          {cardItem[socialCardKeys.workTitle]}
        </a>
        :
          (cardItem[socialCardKeys.authorTagline] && cardItem[socialCardKeys.authorTagline]!=='') ?
            <a className='text-base' href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary), textDecoration: 'none', fontSize:'14px', fontWeight:'400', lineHeight:'15px', letterSpacing:'-0.005em', margin:'2px 0px 0px 0px' } : { color: (cardFontColor || textColors.light.primary), textDecoration: 'none', fontSize:'14px', fontWeight:'400', lineHeight:'15px', letterSpacing:'-0.005em', margin:'2px 0px 0px 0px' }} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer noopener">
            {cardItem[socialCardKeys.authorTagline]}
            </a>
            :
              (cardItem[socialCardKeys.authorUsername] && cardItem[socialCardKeys.authorUsername]!=='') ?
                <a href={cardItem[socialCardKeys.messageLink] || void(0)} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.primary), textDecoration: 'none', fontWeight:'400', lineHeight:'15px', letterSpacing:'-0.005em', margin:'2px 0px 0px 0px', fontSize: '13.5px' } : { color: (cardFontColor || textColors.light.primary), textDecoration: 'none', fontWeight:'400', lineHeight:'15px', letterSpacing:'-0.005em', margin:'2px 0px 0px 0px', fontSize: '13.5px' }} target={cardItem[socialCardKeys.messageLink]?"_blank":"_self"} rel="noreferrer noopener">
                {`@${cardItem[socialCardKeys.authorUsername]}`}
                </a>
                :
                null
        }
    </div>
    <div className="graphic-brand-header">
     
     {RenderGraphicIcon(cardItem[socialCardKeys.socialCardType],cardItem[socialCardKeys.messageLink])}



    </div>
  </div>
  <div className={ClassNames("tweet-content",fontStyle && fontStyle!==''?`font-${fontStyle}`:'')} style={{ color: !darkModeEnabled ? (cardFontColor || textColors.black.primary) : (cardFontColor || textColors.light.primary), fontSize: !smallSize?"1.05em":"1.0em",lineHeight: !smallSize? '1.5em': '1.625em', margin: '1em 0' }}>
    <p>
    {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!==''?
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={cardItem[socialCardKeys.messageContent]} parse={parse} options={options} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(cardItem[socialCardKeys.messageContent], options)
                  :
                  null
               }
    </p>

    {
                  cardItem[socialCardKeys.messageMediaImage] ?

                  cardItem[socialCardKeys.socialCardType]===SOCIAL_CARD_TYPE.DISCORD?
                  <div className="mt-4 flex justify-center w-full" style={{width: '100%', position: 'relative'}}>

                  <img className="h-auto w-auto rounded-md" onLoad={()=>refresh()} objectFit="contain" style={{ width: '100%', borderRadius:'10px', objectFit: 'contain' }} src={cardItem[socialCardKeys.messageMediaImage]} alt="Image" />

               </div>
                  :
                  <div className="mt-4 flex justify-center w-full" style={{width: '100%', position: 'relative'}}>

                     <img loading="lazy" className="h-auto w-auto rounded-md" onLoad={()=>refresh()} priority={true} layout="fill" objectFit="contain" style={{ width: '100%', borderRadius:'10px', objectFit: 'contain' }} src={cardItem[socialCardKeys.messageMediaImage]} alt="Image" />

                  </div>
                  :
                  null
          }
  </div>


  {
              
                  cardItem[socialCardKeys.messageVideoThumbnail] ?
                  <div className='relative'>
                  <a className="mt-4 flex justify-center w-full" style={{width: '100%', position: 'relative'}} href={cardItem[socialCardKeys.messageLink]} target="_blank" rel="noreferrer noopener">


                  {/* <img className="h-45 w-auto" loading='lazy' style={{ width: '100%', height: 200, objectFit: 'contain' }} src={cardItem[socialCardKeys.messageVideoThumbnail]} alt="Video" /> */}

                  <img className="h-auto w-auto rounded-md" onLoad={()=>refresh()} priority={true} layout="fill" objectFit="contain" style={{ width: '100%', borderRadius:'10px', objectFit: 'contain' }} src={cardItem[socialCardKeys.messageVideoThumbnail]} alt="Video" />


                  <div
  aria-label="Play this video"
  role="button"
  tabIndex={0}
  style={{position:'absolute',left: 0, right: 0, top:0, bottom: 0, marginLeft: 'auto', marginRight: 'auto',WebkitBoxDirection:"normal",WebkitBoxOrient:"vertical",flexDirection:"column",backgroundColor: 'rgb(29, 155, 240)', outlineStyle:'none', borderWidth:'4px', borderColor: 'rgb(29, 155, 240)', width:'30px', height: '30px', borderRadius:"9999px",borderStyle:"solid",MsFlexAlign:"stretch",MsFlexDirection:"column",MsFlexNegative:"0",MsFlexPreferredSize:"auto",WebkitAlignItems:"stretch",WebkitBoxAlign:"stretch",WebkitBoxDirection:"normal",WebkitBoxOrient:"vertical",WebkitFlexBasis:"auto",WebkitFlexDirection:"column",WebkitFlexShrink:"0",alignItems:"stretch",border:"0 solid black",boxSizing:"border-box",display:"flex",flexBasis:"auto",flexDirection:"column",flexShrink:"0",marginBottom:"auto",marginTop:"auto",minHeight:"0px",minWidth:"0px",paddingBottom:"0px",paddingLeft:"0px",paddingRight:"0px",paddingTop:"0px",zIndex:"0"}}
>
  <div style={{position:'absolute', WebkitBoxDirection:"normal",WebkitBoxOrient:"vertical",flexDirection:"column",WebkitBoxAlign:"center",alignItems:"center",WebkitBoxPack:"center",justifyContent:"center",height:"100%",width:"100%", MsFlexAlign:"stretch",MsFlexDirection:"column",MsFlexNegative:"0",MsFlexPreferredSize:"auto",WebkitAlignItems:"stretch",WebkitBoxAlign:"stretch",WebkitBoxDirection:"normal",WebkitBoxOrient:"vertical",WebkitFlexBasis:"auto",WebkitFlexDirection:"column",WebkitFlexShrink:"0",alignItems:"stretch",border:"0 solid black",boxSizing:"border-box",display:"flex",flexBasis:"auto",flexDirection:"column",flexShrink:"0",marginBottom:"0px",marginLeft:"0px",marginRight:"0px",marginTop:"0px",minHeight:"0px",minWidth:"0px",paddingBottom:"0px",paddingLeft:"0px",paddingRight:"0px",paddingTop:"0px",position:"relative",zIndex:"0"}}>
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      style={{paddingLeft:"3px",marginLeft:'auto',marginRight:'auto',width:"calc(50% + 4px)",color:"rgb(255, 255, 255)",MozUserSelect:"none",MsUserSelect:"none",WebkitUserSelect:"none",userSelect:"none",verticalAlign:"text-bottom",position:"relative,\nheight: calc(50% + 4px)",maxWidth:"100%",fill:"currentcolor",display:"inline-block"}}
    >
      <g>
        <path d="M21 12L4 2v20l17-10z" />
      </g>
    </svg>
  </div>
</div>
               </a>
               </div>
               :
               null
               }
  
                    <div className="mt-2">
                    {
                       (cardItem[socialCardKeys.starRating] && cardItem[socialCardKeys.starRating]>0) ? 
                       <ul className="flex" style={{marginTop:2, paddingBottom: '1em'}}>
                       {
                         [...Array(Math.min(5,Math.floor(cardItem[socialCardKeys.starRating])))].map((e,i) =>
                       <li key={e}>
                         <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star" className="w-4 " style={{color:ratingColor?ratingColor:'#f59e0b'}}
                           role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                           <path fill="currentColor"
                             d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z">
                           </path>
                         </svg>
                       </li>
                         )
                       }
                       {
                        (cardItem[socialCardKeys.starRating]%1===0.5) &&
                           <li>
                           <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="star-half-alt"
                             className="w-4 " style={{color:ratingColor?ratingColor:'#f59e0b'}} role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 536 512">
                             <path fill="currentColor"
                               d="M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z">
                             </path>
                           </svg>
                         </li>
                       }
    
                     </ul>
                           :
                           null
                    }
                    <div className={fontStyle && fontStyle!==''?`font-${fontStyle}`:''} style={!darkModeEnabled ? { color: (cardFontColor || textColors.black.secondary), fontSize: 13 } : { color: (cardFontColor || textColors.light.secondary), fontSize: 13 }}>
                    <span>{(!isDateTimeDisabled && cardItem[socialCardKeys.messageTime])?dayjs(cardItem[socialCardKeys.messageTime]).locale('en').format('DD MMM YYYY'):null}</span>
                    </div>
                 </div>
                  

</div>

    


</div>
    );
};

export default GraphicCard;

